import { SortDirection } from '../../../../utils/constants';
import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';

export const filterFields = {
  targetName: 'TargetName',
  active: 'Active',
};

const initialFilterState = {
  TargetName: '',
  Active: true,
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'TargetName',
  sortDirection: SortDirection.Desc,
};

export const sliceName = 'targetSearch';
const targetSearchSlice = createSearchPageSlice({
  sliceName,
  filterFields,
  initialFilterState,
  initialPageState
});

export const targetSearchActions = targetSearchSlice.actions;
export default targetSearchSlice.reducer;
